import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import AirlinesTable from "../../components/airlines/AirlinesTable";

const Airlines = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <AirlinesTable />
        </WrapperSection>
    );
};

export default Airlines;
